import CommonHelmet from '@src/components/CommonHelmet';
import TenantRoleGuard from '@src/components/guard/TenantRoleGuard';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import ProfileForm from '@src/features/tenant/profile/ProfileForm';
import TenantDefaultLayout from '@src/layouts/tenant/TenantDefaultLayout';

function Profile() {
  return (
    <TenantRoleGuard canRoles={[TENANT_ROLE.ADMIN, TENANT_ROLE.CONTENT, TENANT_ROLE.MEMBER]}>
      <TenantDefaultLayout withoutParentPadding={true}>
        <CommonHelmet />
        <ProfileForm />
      </TenantDefaultLayout>
    </TenantRoleGuard>
  );
}

export default Profile;
